<template>
  <div id="natcon-lom-awards-list">
    <v-card class="pa-5 elevation-3">
      <!-- Page Header -->
      <v-card-title class="d-flex align-center justify-space-between">
        <h2 class="font-weight-bold text-primary">{{ PageTitle }}</h2>
        <v-btn
          @click.prevent="refreshPageData"
          color="success"
          rounded
          class="px-5 py-4 font-weight-bold white--text"
          elevation="4"
          :loading="LoadingFlag"
        >
          <v-icon left>mdi-refresh</v-icon>
          Refresh
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        <h4 class="font-weight-regular text--secondary">
          {{ PageDescription }}
        </h4>
      </v-card-subtitle>
      <v-divider class="mb-5"></v-divider>

      <v-card-text>
        <!-- Filter Section -->
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row dense>
              <!-- Select Type -->
              <v-col cols="12" sm="6" md="3">
                <h6 class="font-weight-medium mb-2">
                  <span class="text-danger">*</span> Select Type
                </h6>
                <v-select
                  v-model="selectedType"
                  :items="typeOptions"
                  :rules="[(v) => !!v || 'Type is required']"
                  placeholder="Choose Type"
                  outlined
                  dense
                  clearable
                  required
                ></v-select>
              </v-col>

              <!-- Zone -->
              <v-col cols="12" sm="6" md="3" v-if="selectedType === '1'">
                <h6 class="font-weight-medium mb-2">
                  <span class="text-danger">*</span> Zone
                </h6>
                <v-autocomplete
                  :items="ZoneCodeOptions"
                  :reduce="(option) => option.value"
                  :loading="ZoneCodeOptionsLoading"
                  :rules="ZoneCodeRules"
                  v-model="ZoneCode"
                  outlined
                  dense
                  clearable
                  required
                  placeholder="Select Zone"
                ></v-autocomplete>
              </v-col>

              <!-- LOM -->
              <v-col cols="12" sm="6" md="3" v-if="selectedType === '1'">
                <h6 class="font-weight-medium mb-2">
                  <span class="text-danger">*</span> LO
                </h6>
                <v-autocomplete
                  :items="LomCodeOptions"
                  :reduce="(option) => option.value"
                  :loading="LomCodeOptionsLoading"
                  :rules="LomCodeRules"
                  v-model="LomCode"
                  outlined
                  dense
                  clearable
                  required
                  placeholder="Select LO"
                ></v-autocomplete>
              </v-col>

              <!-- Member -->
              <v-col cols="12" sm="6" md="3" v-if="selectedType === '2'">
                <h6 class="font-weight-medium mb-2">
                  <span class="text-danger">*</span> Membership ID
                </h6>
                <v-text-field
                  v-model="MembershipId"
                  :rules="MembershipIdRules"
                  outlined
                  dense
                  clearable
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Search Button -->
            <v-row justify="center" class="mt-6">
              <v-btn
                @click.prevent="getAutoScore"
                color="primary"
                class="px-10 py-5 white--text font-weight-bold text-h6"
                rounded
                elevation="6"
                :loading="SubmitFlag"
                :disabled="SubmitFlag"
              >
                <v-icon left>mdi-magnify</v-icon>
                Search
              </v-btn>
            </v-row>
          </v-container>
        </v-form>

        <!-- Results Section -->
        <v-container class="mt-8">
          <v-row justify="center">
            <v-col cols="12" md="12" align="center">
              <h3 class="font-weight-bold text-primary">
                {{ rows.length }} records found
              </h3>
            </v-col>
          </v-row>

          <!-- Data Table -->
          <v-row>
            <v-col cols="12" md="12">
              <v-data-table
                v-if="rows.length >= 0"
                :headers="tableColumns1"
                :items="rows"
                :loading="StartupLoadingFlag"
                loading-text="Loading... Please wait"
                class="elevation-2 styled-table"
                dense
              >
                <!-- Serial Number Column -->
                <template v-slot:item.slNo="{ index }">
                  {{ index + 1 }}
                </template>

                <!-- Status Column -->
                <template v-slot:item.AwardStatusTxt="{ item }">
                  <v-chip :color="item.AwardStatusColor" dark small>
                    {{ item.AwardStatusTxt }}
                  </v-chip>
                </template>

                <!-- No Data -->
                <template v-slot:no-data>
                  <v-alert type="info" text>No records found.</v-alert>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      selectedType: "",
      typeOptions: [
        { text: "For LO", value: "1" },
        { text: "For Member", value: "2" },
      ],
      StartupLoadingFlag: false,
      LoadingFlag: false,
      SubmitFlag: false,
      CardLoadingFlag: false,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      LomCodeRules: [(v) => !!v || "LO is required"],
      LomCode: 0,
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership Id is required"],

      rows: [],
      tableOptions1: [],
      tableColumns1: [],

      recordData: {},

      openLomDetailsPrompt: false,
      previewRecordPrompt: false,

      valid: true,

      RoleId: 0,
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        var zone_name = this.$session.get("ZoneName");
        zone_name = zone_name == (null || undefined) ? 0 : zone_name;

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.ZoneCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LomCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode Called");
      this.getLomCodeOptions();
    },
    LomCode: function () {
      console.log("watch LomCode Called");
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "conference_settings",
        Action: "list_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.reset();
    },
    pageData() {
      console.log("pageData called");
      this.getZoneCodeOptions();
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = true;
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/year-wise-lom/zone-options";
      var selectbox1_conditions_array = {
        UserInterface: 4,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var ZoneCode = this.ZoneCode;
      console.log({ ZoneCode });
      if (ZoneCode != "") {
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        message += "Zone should not be empty. ";
      }
    },
    reset() {
      console.log("reset called");
      if (this.$refs.form) this.$refs.form.reset();
      this.rows = [];
      this.tableColumns1 = [];
      this.selectedType = "";
      this.ZoneCode = "";
      this.LomCode = "";
      this.MembershipId = "";
    },
    getAutoScore() {
      console.log("getAutoScore called");

      // Validate form
      if (!this.$refs.form.validate()) {
        this.toast("error", "Please fill all required fields");
        return;
      }

      // Validate based on selected type
      if (this.selectedType === "1") {
        if (!this.ZoneCode || !this.LomCode) {
          this.toast("error", "Please select Zone and LO");
          return;
        }
      } else if (this.selectedType === "2") {
        if (!this.MembershipId) {
          this.toast("error", "Please enter Membership ID");
          return;
        }
      } else {
        this.toast("error", "Please select a type");
        return;
      }

      var validate1 = true;
      console.log({ validate1 });

      if (validate1) {
        this.SubmitFlag = true;
        this.rows = [];
        this.tableColumns1 = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award-type/jci-india-score";
        if (this.selectedType == 1) {
          // For Admin
          var upload = {
            UserInterface: 3,
            Lom: this.LomCode,
          };
        } else {
          // For Others
          var upload = {
            UserInterface: 2,
            Membership: this.MembershipId,
          };
        }
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.IndividualAward = [];

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.StartupLoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log("records=" + records);

            var options = records.TableOptions;
            thisIns.tableOptions1 = options;

            if (flag == 1) {
              thisIns.SubmitFlag = false;
              console.log({ records });
              //   thisIns.tableColumns1 = records.TableHeader;

              thisIns.rows = records.ScoringData;
              thisIns.tableColumns1 = records.ScoringHeader;

              thisIns.toast("success", output);
            } else {
              thisIns.SubmitFlag = false;
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.SubmitFlag = false;
            console.log("error=" + error);
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "";
        console.log("error=" + message);
      }
    },
    previewAlert(tr) {
      console.log("previewAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.recordData = tr;
        this.previewRecordPrompt = true;
      } else {
        var message = "Kindly select one record to preview";
        this.errorMessage(message);
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    hideLomDetailsPrompt() {
      console.log("hideLomDetailsPrompt called");
      this.openLomDetailsPrompt = false;
    },
  },
  beforeMount() {
    console.log("beforeMount called");

    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? "" : RoleId;
    console.log({ RoleId });
    this.RoleId = RoleId;

    this.refreshPageData();
  },
};
</script>

<style lang="scss">
#natcon-lom-awards-list {
  h2,
  h3,
  h6 {
    font-family: "Poppins", sans-serif;
  }

  .v-data-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .styled-table {
    background-color: #fafafa;

    th {
      background-color: #1976d2 !important;
      color: white !important;
      font-weight: 600;
      text-align: center;
    }

    td {
      text-align: center;
    }
  }

  .text-primary {
    color: #1976d2 !important;
  }

  .v-card {
    border-radius: 12px;
  }

  .v-btn {
    text-transform: none !important;
  }
}
</style>
